export default "__VITE_ASSET__Blt7d$5$__"